"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const CompanyAndTags_1 = __importDefault(require("../CompanyAndTags"));
var Talk = function Talk(_ref) {
    var date = _ref.date, title = _ref.title, notes = _ref.notes, slug = _ref.slug, organisation = _ref.organisation, tags = _ref.tags;
    return /*#__PURE__*/ react_1.default.createElement("div", {
        className: "card"
    }, /*#__PURE__*/ react_1.default.createElement("div", null, /*#__PURE__*/ react_1.default.createElement("p", {
        style: {
            marginBottom: "-1rem"
        }
    }, new Date(date).toLocaleDateString("en-GB", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    })), /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/speaking/" + slug
    }, /*#__PURE__*/ react_1.default.createElement("h3", null, title))), /*#__PURE__*/ react_1.default.createElement(CompanyAndTags_1.default, {
        organisation: organisation,
        tags: tags
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "notes",
        dangerouslySetInnerHTML: {
            __html: notes
        }
    }));
};
exports.default = Talk;
